export default "__VITE_ASSET__Bff7yp4$__"